import React from "react";
import styles from "./ColorIndicator.module.css";

const ColorIndicator = ({ title, color, isDark = false }) => {
  // If no color or invalid color
  if (!color || !Array.isArray(color) || color.length === 0) {
    return (
      <div className={styles.colorIndicatorRow}>
        <span>{title}</span>
        <div
          className={styles.colorIndicator}
          style={{ backgroundColor: "#888888" }}
        ></div>
      </div>
    );
  }

  // If the mode is light look for the light theme,
  // else look for the dark theme
  // If there is only one theme, use that.
  // This is all a bit brittle.
  const getTheme = () => {
    if (color.length === 1) return color[0];
    if (isDark) {
      // Look for dark theme
      const darkTheme = color.find((t) => t.name.includes("dark"));
      if (darkTheme) {
        return darkTheme;
      }
    } else {
      // Look for light theme
      const lightTheme = color.find((t) => t.name.includes("light"));
      if (lightTheme) {
        return lightTheme;
      }
    }
  };

  const theme = getTheme(color);

  return (
    <div
      className={styles.colorIndicatorRow}
      style={{
        backgroundColor: theme.themeColor || "#ffffff",
        borderColor: theme.frameBorderColor || theme.themeColor,
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "4px",
      }}
      title="Theme background color"
    >
      <span
        style={{
          color: theme.primaryTextColor,
          padding: "0 4px",
        }}
        title="Primary text color"
      >
        {title}
      </span>
      <div className={styles.colorIndicators}>
        <div
          className={styles.colorHighlight}
          style={{
            backgroundColor: theme.themeSecondaryColor,
          }}
          title="Theme Foreground Color"
        ></div>
        <div
          className={styles.colorHighlight}
          style={{
            backgroundColor: theme.attentionColor,
          }}
          title="Attention Color"
        ></div>
        <div
          className={styles.colorHighlight}
          style={{
            backgroundColor: theme.accentColor,
          }}
          title="Accent Color"
        ></div>
        <div
          className={styles.colorHighlight}
          style={{
            backgroundColor: theme.warningColor,
          }}
          title="Warning Color"
        ></div>
      </div>
    </div>
  );
};

export default ColorIndicator;
